import React, { useState, createContext, useContext } from 'react'
import { ChannelFilters, DefaultGenerics } from 'stream-chat'
import { DefaultStreamChatGenerics } from 'stream-chat-react'

interface ChatContextType {
  chatFilters: ChannelFilters<DefaultGenerics | DefaultStreamChatGenerics>
  setChatFilters: React.Dispatch<React.SetStateAction<ChannelFilters>>
  showProfile: boolean
  setShowProfile: React.Dispatch<React.SetStateAction<boolean>>
  eventId?: string
  userId: string
}

const ChatContext = createContext<ChatContextType | null>(null)

export function useChat() {
  const context = useContext(ChatContext)
  if (!context) {
    throw new Error('useChat must use used within a chat <Chat />')
  }
  return context
}

export function ChatContent({
  children,
  eventId,
  userId,
}: {
  children: React.ReactNode
  eventId?: string
  userId: string
}) {
  const [chatFilters, setChatFilters] = useState<
    ChannelFilters<DefaultGenerics | DefaultStreamChatGenerics>
  >({})
  const [showProfile, setShowProfile] = useState(true)

  return (
    <ChatContext.Provider
      value={{
        chatFilters,
        setChatFilters,
        eventId,
        userId,
        showProfile,
        setShowProfile,
      }}
    >
      {children}
    </ChatContext.Provider>
  )
}

export function ChatFilters({ children }: { children: React.ReactNode }) {
  const [selectedTab, setSelectedTab] = useState(0)

  return (
    <div className="space-x-2">
      {React.Children.map(children, (child, index) => {
        return React.cloneElement(child as React.ReactElement, {
          focused: index === selectedTab,
          onClick: () => setSelectedTab(index),
        })
      })}
    </div>
  )
}
